import { Button, Flex, Text } from '@chakra-ui/react';
import CalendarPickerPill from '@components/common/CalendarPickerPill';
import SearchInput from '@components/common/SearchInput';
import { fakePredictionHistory } from '@features/positions/predictions/fakeData';
import HistoryDetailDialog from '@features/positions/predictions/HistoryDetailDialog';
import HistoryTable from '@features/positions/predictions/HistoryTable';
import { PredictionHistoryEntry } from '@features/positions/predictions/types';
import { memo, useCallback, useMemo, useState } from 'react';
import { DownloadIcon } from 'vectors';

const HistoryTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedEntry, setSelectedEntry] = useState<PredictionHistoryEntry | null>(null);

  const handleClear = useCallback(() => {
    setSearchQuery('');
  }, []);

  const handleRowClick = useCallback((entry: PredictionHistoryEntry) => {
    setSelectedEntry(entry);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setSelectedEntry(null);
  }, []);

  const handleExport = useCallback(() => {
    // TODO: implement export
  }, []);

  const filteredHistory = useMemo(() => {
    if (searchQuery.trim() === '') {
      return fakePredictionHistory;
    }
    const q = searchQuery.toLowerCase();
    return fakePredictionHistory.filter((e) => e.market.toLowerCase().includes(q));
  }, [searchQuery]);

  return (
    <Flex direction="column" gap={3}>
      <Flex
        direction={{ base: 'column', sm: 'row' }}
        gap={2}
        alignItems={{ base: 'stretch', sm: 'center' }}
        pt={3}
      >
        <SearchInput
          query={searchQuery}
          setQuery={setSearchQuery}
          onClear={handleClear}
          placeholder="Search"
          size="sm"
          flex={1}
        />
        <Flex ml={{ base: '0', sm: 'auto' }} gap={2} alignItems="center">
          <CalendarPickerPill />
          <Button variant="outline" size="sm" borderRadius="md" onClick={handleExport}>
            <DownloadIcon boxSize={4} />
            Export
          </Button>
        </Flex>
      </Flex>
      {filteredHistory.length > 0 ? (
        <HistoryTable entries={filteredHistory} onRowClick={handleRowClick} />
      ) : (
        <Text color="text.secondary" fontSize="sm" textAlign="center" py={8}>
          You haven&apos;t traded any polymarkets yet
        </Text>
      )}
      <HistoryDetailDialog
        entry={selectedEntry}
        open={selectedEntry != null}
        onClose={handleCloseDialog}
      />
    </Flex>
  );
};

export default memo(HistoryTab);
